// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"static-website-latest"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import {
    sentryIgnoreExceptionTypes,
    sentryIgnoreExceptionValues,
    sentryIgnoreMessages,
} from '@/utils/sentryIgnoreList';

import { env } from '@/env.mjs';

if (env.NEXT_PUBLIC_ENVIRONMENT !== 'devenv') {
    Sentry.init({
        enabled: true, // false to disable sentry

        dsn: env.NEXT_PUBLIC_SENTRY_DSN,
        environment: env.NEXT_PUBLIC_ENVIRONMENT + '_client',

        allowUrls: [
            // Production domains
            /https?:\/\/(www\.)?paypo\.pl/,
            /https?:\/\/api\.paypo\.pl/,
            // Sandbox environment
            /https?:\/\/sandbox\.paypo\.pl/,
            // Dynamic QA environments
            /https?:\/\/qa\d{3}\.pl\.paypo\.online/,
        ],
        denyUrls: [
            // Third-party services
            /googletagmanager\.com/i,
            /google-analytics\.com/i,
            /region1\.google-analytics\.com/i,
            /pagead2\.googlesyndication\.com/i,
            /ct\.pinterest\.com/i,
            /paypo\.user\.com/i,
            // Browser extensions
            /extensions\//i,
            /^chrome:\/\//i,
        ],

        // Adjust this value in production, or use tracesSampler for greater control
        tracesSampleRate: 0.001,

        // Setting this option to true will print useful information to the console while you're setting up Sentry.
        debug: false,

        replaysOnErrorSampleRate: 0.0,

        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.0,

        profilesSampleRate: 0.001,

        // You can remove this option if you're not planning to use the Sentry Session Replay feature:
        integrations: [
            // Sentry.replayIntegration({
            //     // Additional Replay configuration goes in here, for example:
            //     maskAllText: true,
            //     blockAllMedia: true,
            // }),
            Sentry.linkedErrorsIntegration(),
            Sentry.extraErrorDataIntegration(),
            Sentry.httpClientIntegration(),
            Sentry.thirdPartyErrorFilterIntegration({
                filterKeys: ['PayPo-application-sentry-key'],
                behaviour: 'drop-error-if-contains-third-party-frames',
            }),
        ],

        beforeSend(event) {
            if (
                event?.exception &&
                event.exception?.values &&
                event.exception.values[0]
            ) {
                const { value, type } = event.exception.values[0];

                if (
                    sentryIgnoreExceptionValues.some(ignoreValue =>
                        value
                            ?.toLowerCase()
                            .includes(ignoreValue.toLowerCase()),
                    ) ||
                    sentryIgnoreExceptionTypes.some(ignoreType =>
                        type?.toLowerCase().includes(ignoreType.toLowerCase()),
                    )
                ) {
                    return null;
                }
            }

            if (
                event?.message &&
                sentryIgnoreMessages.some(ignoreMessage =>
                    event?.message
                        ?.toLowerCase()
                        .includes(ignoreMessage.toLowerCase()),
                )
            ) {
                return null;
            }

            // Ignore user.com
            if (event.request?.url?.includes('paypo.user.com')) {
                return null;
            }
            if (
                event.exception?.values?.[0]?.value === 'db' &&
                event.contexts?.trace?.data?.url?.includes('paypo.user.com')
            ) {
                return null;
            }

            return event;
        },
    });
}
